const versions = new Map();
export const getColumnMapVersion = propertyUtilityId => {
  var _versions$get;
  return (_versions$get = versions.get(propertyUtilityId)) !== null && _versions$get !== void 0 ? _versions$get : 0;
};
export const noteColumnMapChange = propertyUtilityId => {
  versions.set(propertyUtilityId, getColumnMapVersion(propertyUtilityId) + 1);
};